/*eslint-disable no-script-url*/

import React from 'react';
import ReactTags from '../reactTag/ReactTags';
// import {COUNTRIES} from '../home/partials/countries';
import Header from './includes/Header';
import Footer from "./includes/Footer";
import {About} from './includes/About';
import {MODEL, URLS, PAGES} from "../../common/Globals";
import axios from 'axios';

import './en-css/style-en.css';
import './en-css/tags.css';
import './en-css/howToUse.css';
import './en-css/top-header.css';
import './en-css/footer.css';
import './en-css/home.css';
import EnResult from "./partials/EnResult";
import HeResult from "./partials/HeResult";
import {ApiCall} from "../../actions/HttpCall";
// import Loader from "../../common/Loader";
// import FindDifferentFromEn from "./partials/FindDifferentFromEn";
// import FindDifferentFromHe from "./partials/FindDifferentFromHe";
import $ from 'jquery';

const KeyCodes = {
    enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

class Index extends React.Component{
    state = {
        tags: [],
        suggestions: [],
        noResults: false,
        models: '',
        selectedModel: MODEL.FULL_HEBREW,
        results: [],
        pageState: PAGES.EN,
        editSuggestionPopup: {
            show: false,
            text: ''
        },
        textCopyNotification: false,
        isInDictionary: true
    };


    componentDidMount() {
        this.fetchModels();

        // let react = this;

        // $(".react-tags__search-input").on('keyup', function (e) {
        //     if (e.keyCode === 13) {
        //         // Do something
        //
        //         let input = document.getElementsByClassName('react-tags__search-input')[0].children[0];
        //         let val =  input.value;
        //         react.handleTagNotInDictionary({id: val, name: val});
        //
        //         setTimeout(() => {
        //
        //             document.getElementsByClassName('react-tags__search-input')[0].children[0].value = '';
        //             var elem = document.getElementsByClassName('react-tags__search-input')[0].children[0];
        //
        //             var press = $.Event("keyup");
        //             press.ctrlKey = false;
        //             press.which = 20;
        //
        //             $(elem).keyup(function(e){
        //                 alert(e.which);
        //             })
        //
        //         },20);
        //
        //     }
        // });
    }

    handleDelete = (i) => {
        const { tags } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        }, () => {
            if (this.state.tags.length > 0){
                this.fetchIdentity();
            } else {
                this.setState({
                    results: []
                })
            }
        });
    };

    handleAddition = (tag) => {
        if (this.state.suggestions.length > 0){
            this.setState(state => ({ tags: [...state.tags, tag]}), () => {
                this.fetchIdentity();
            });
        }
    };

    // handleTagNotInDictionary = tag => {
    //
    //     this.setState(state => ({ tags: [...state.tags, tag], tagStatus: [...state.tagStatus, false] }), () => {
    //
    //         let parent =  document.getElementsByClassName('react-tags__selected');
    //         parent = parent[0].children;
    //
    //         for(let x=0;x<parent.length;x++)
    //         {
    //             if(!this.state.tagStatus[x])
    //             {
    //                 parent[x].classList.add("error");
    //             }
    //         }
    //
    //     });
    // };

    fetchIdentity =() => {
        let words = this.state.tags.map(obj => obj.name.toLowerCase());
        let body = {
            model: this.state.selectedModel,
            words
        };

        ApiCall(`${URLS.BASE}${URLS.IDENTITY}`, 'POST', JSON.stringify(body), res => {

            this.setState({results: res, noResults: res.length === 0});
        }, true);
    };

    handleTagClick = (index) => {
        console.log('The tag at index ' + index + ' was clicked');
    };

    fetchSuggestions = (e, cb = null) => {
        let body = {
            text: e,
            model: this.state.selectedModel
        };

        ApiCall(`${URLS.BASE}${URLS.SUGGESTIONS}`, 'POST', JSON.stringify(body), res => {
            const suggestions = res.map((suggestion) => {
                return {
                    id: suggestion,
                    name: suggestion
                }
            });

            if (cb){
                cb(suggestions);
            }

            let isInDictionary = suggestions.length !== 0;

            this.setState({suggestions, isInDictionary});

            setTimeout(() => {
                this.setState({
                    isInDictionary: true
                })
            }, 3000);
        }, false);
    };

    fetchModels = () => {
        axios.get(`${URLS.BASE}${URLS.MODEL}`)
            .then(res => {
                this.setState({
                    models: res.data
                });
                $('#loader').hide();
            })
            .catch(error => {
                console.log(error);
                $('#loader').hide();
            });
    };

    handleModelSelect = selectedModel => {
        this.setState({selectedModel, tags: [], results: []})
    };

    handlePageState = pageState => this.setState({pageState});

    handleSuggestedEditPopupShow = show => {
        let editSuggestionPopup = this.state.editSuggestionPopup;
        editSuggestionPopup.show = show;

        this.handleEditSuggestionPopup(editSuggestionPopup);
    };

    handleSuggestedEditPopupText = e => {
        let editSuggestionPopup = this.state.editSuggestionPopup;
        editSuggestionPopup.text = e.target.value;

        this.handleEditSuggestionPopup(editSuggestionPopup);
    };

    handleSendSuggestedEdit = () => {
        let words = this.state.tags.map(obj => obj.text);
        let body = {
            model: this.state.selectedModel,
            words,
            suggestedText: this.state.editSuggestionPopup.text
        };

        axios.post(URLS.EMAIL, body)
            .then(res => {
                console.log(res);
            });

        this.handleSuggestedEditPopupShow(false);
    };

    handleTextCopyNotification = text => {

        let dummy = document.createElement("input");

        // Add it to the document
        document.body.appendChild(dummy);

        // Set its ID
        dummy.setAttribute("id", "dummy_id");

        // Output the array into it
        document.getElementById("dummy_id").value=text;

        // Select it
        dummy.select();

        // Copy its contents
        document.execCommand("copy");

        // Remove it as its not needed anymore
        document.body.removeChild(dummy);

        this.setState({textCopyNotification: true});

        setTimeout(() => {
            this.setState({textCopyNotification: false});
        }, 3000)
    };

    handleEditSuggestionPopup = editSuggestionPopup => this.setState({editSuggestionPopup});

    render(){
        const { tags } = this.state;
        return(
            <div className={this.state.pageState}>
                <Header
                    {...this.props}
                    {...this.state}
                    handleModelSelect={this.handleModelSelect}
                    handlePageState={this.handlePageState}
                />
                <input type="hidden" id="copy-text"/>
                <div className={'main-contant'}>
                    <div className={'en-main-contant'}>
                        <div className="container">
                            <div className={'columns-holder'}>
                                <div className={'row'}>
                                    <div className={'col-sm-6'}>
                                        <div className={'heading-txt'}>
                                            <h3 className={'f black'}>Find a word similar to:</h3>
                                        </div>
                                        <div className={'txt-frame first'}>
                                            <ReactTags
                                                tags={tags}
                                                suggestions={this.state.suggestions}
                                                maxSuggestionsLength={100}
                                                minQueryLength={1}
                                                delimiters={delimiters}
                                                handleDelete={this.handleDelete}
                                                handleAddition={this.handleAddition}
                                                // handleDrag={this.handleDrag}
                                                handleTagClick={this.handleTagClick}
                                                handleInputChange={this.fetchSuggestions}
                                                placeholder={'enter a word'}
                                            />
                                            {!this.state.isInDictionary ?
                                                <p style={{color: 'red'}} className={'error'}>The word you typed is not in our word list</p> : null
                                            }

                                        </div>


                                        {/*<FindDifferentFromEn/>*/}

                                    </div>
                                    {this.state.pageState === PAGES.EN ?
                                        <EnResult
                                            results={this.state.results}
                                            tags={this.state.tags}
                                            noResults={this.state.noResults}
                                            editSuggestionPopup={this.state.editSuggestionPopup}
                                            textCopyNotification={this.state.textCopyNotification}
                                            handleEditSuggestionPopup={this.handleEditSuggestionPopup}
                                            handleSuggestedEditPopupShow={this.handleSuggestedEditPopupShow}
                                            handleSuggestedEditPopupText={this.handleSuggestedEditPopupText}
                                            handleSendSuggestedEdit={this.handleSendSuggestedEdit}
                                            handleTextCopyNotification={this.handleTextCopyNotification}
                                        /> : null
                                    }
                                </div>
                            </div>
                        </div>
                        {this.state.textCopyNotification ?
                            <div className={'show-message'}>
                                <p className={'f white'}>Text copied successfully</p>
                            </div> : null
                        }

                    </div>
                    <div className={'he-main-contant'}>
                        <div className="container">
                            <div className={'columns-holder'}>
                                <div className={'row'}>

                                    <div className={'col-sm-6'}>
                                        <div className={'heading-txt'}>
                                            <h3 className={'f black'}>חפשו מילה הדומה ל:</h3>
                                        </div>
                                        <div className={'txt-frame first'}>
                                            <ReactTags
                                                tags={tags}
                                                suggestions={this.state.suggestions}
                                                maxSuggestionsLength={100}
                                                minQueryLength={1}
                                                delimiters={delimiters}
                                                handleDelete={this.handleDelete}
                                                handleAddition={this.handleAddition}
                                                // handleDrag={this.handleDrag}
                                                handleTagClick={this.handleTagClick}
                                                handleInputChange={this.fetchSuggestions}
                                                placeholder={'הזן מילה'}
                                            />
                                            {!this.state.isInDictionary ?
                                                <p style={{color: 'red'}} className={'error'}>המילה שהזנת אינה כלולה במאגר המילים שלנו</p> : null
                                            }
                                        </div>

                                        {/*<FindDifferentFromHe/>*/}

                                    </div>

                                    {this.state.pageState === PAGES.HE ?
                                        <HeResult
                                            results={this.state.results}
                                            tags={this.state.tags}
                                            noResults={this.state.noResults}
                                            editSuggestionPopup={this.state.editSuggestionPopup}
                                            textCopyNotification={this.state.textCopyNotification}
                                            handleEditSuggestionPopup={this.handleEditSuggestionPopup}
                                            handleSuggestedEditPopupShow={this.handleSuggestedEditPopupShow}
                                            handleSuggestedEditPopupText={this.handleSuggestedEditPopupText}
                                            handleSendSuggestedEdit={this.handleSendSuggestedEdit}
                                            handleTextCopyNotification={this.handleTextCopyNotification}
                                        /> : null
                                    }



                                </div>
                            </div>
                        </div>

                        {this.state.textCopyNotification ?
                            <div className={'show-message'}>
                                <p className={'f white'}>הטקסט הועתק בהצלחה</p>
                            </div> : null
                        }
                    </div>
                </div>
                <About/>
                <Footer/>

            </div>
        )
    }
}
export default Index


// WEBPACK FOOTER //
// ./src/components/home/Index.js